import type { ComponentProps } from 'react';

import type { RouteObject } from '@suntex.core/nav';
import { RequireAuth } from '@suntex.fim/framework';

import { PlayerLayout } from '../layouts/PlayerLayout';

import { createPlayerRoutes } from './playerRoutes';
import { createPreviewRoutes } from './previewRoutes';

export interface CreatePlayRoutesOptions {
  /** Chrome props forwarded to {@link PlayerLayout} (e.g. `appVersion`). */
  chrome: ComponentProps<typeof PlayerLayout>;
  /** Module routes mounted under both `/modules` and `/preview/modules`; passed in because @suntex.fim/modules depends on this package. */
  moduleRoutes: RouteObject[];
  /** App-specific pages mounted under `/player/*`. */
  playerPages?: RouteObject[];
}

/**
 * Builds the shared play surfaces: the `/player` hub, `/preview`, and
 * `/modules`. The same module routes back both `/modules` and
 * `/preview/modules`, so play and preview stay in step across apps. Every
 * route is auth-gated, so apps mount these at the router's top level.
 */
export function createPlayRoutes({
  chrome,
  moduleRoutes,
  playerPages,
}: CreatePlayRoutesOptions): RouteObject[] {
  return [
    ...createPlayerRoutes({ chrome, playerPages }),
    ...createPreviewRoutes({ chrome, moduleRoutes }),
    {
      path: '/modules',
      element: <RequireAuth />,
      children: [
        {
          element: <PlayerLayout {...chrome} />,
          children: moduleRoutes,
        },
      ],
    },
  ];
}
